export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-all-600-normal.woff?86429f21b60d0dc1105e192111ffb480";